// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"5af0b3db","72":"72841d02","134":"7ee060b4","139":"19c3c313","190":"e60efe9b","229":"575be975","286":"9b500352","409":"2b9ecf73","460":"52fe3709","491":"dc9abd88","500":"50e6681e","563":"a76ff00e","797":"4853b2fc","826":"1ef39b5b"}[chunkId] + ".chunk.js";
};